module.exports = __webpack_public_path__ + "media/src/assets/signup_hands-f80c78e6b5e75ff0bbaf5444e5b10113.svg";